(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.hasAttribute('data-size-guide-events')) {
    document.documentElement.setAttribute('data-size-guide-events', 'true');

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const openButton = event.target.closest('[data-size-guide-open]');
      if (openButton) {
        const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-size-guide-close]');
      if (closeButton) {
        const dialog = closeButton.closest('dialog');
        if (dialog && dialog.open) dialog.close();
        return;
      }

      const clickedDialog = event.target.closest('dialog[data-size-guide-dialog]');
      if (clickedDialog && event.target === clickedDialog) clickedDialog.close();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
